module.exports = __webpack_public_path__ + "f0fd847628abae19116eb914c6d8173c.svg";